import React from 'react';
import Header from '../../../Components/Modules/Includes/Header'
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as actions from '../../../Actions/';
import {donwloadFile} from '../../../helpers/helper';
import { Row, Col, PanelGroup, Panel } from 'react-bootstrap'
import JSONPretty from 'react-json-pretty';
import LinearProgress from 'material-ui/LinearProgress';
import RaisedButton from 'material-ui/RaisedButton'
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

class AdminLogs extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			older : 1
		}

	}

	componentDidMount(){
		this._getSystemLogs();
	}
	_importSystemLogs = () => {
		const {system : {logs, requesting}} = this.props
        donwloadFile(JSON.stringify(logs), `${(new Date).toString()}.log`);
	}

	_getSystemLogs = (value) => {

		let older = 24 * 60 * 60 * 1000

		if(value){
			older = value * older
		}

		this.setState({
			older
		})
		this.props.getSystemLogs({
			older
		});	
		
	}


	render() {
		const {system : {logs, requesting}} = this.props
		var JSONPrettyMon = require('react-json-pretty/dist/monikai');
		return (
			<div>
				<Header />

				<div className="dashboard-page">
					<div className="right-content-dashboard active-dashboard templete-page">
						<div class="page-header" style={{margin: "0px"}}>
							<div class="container-fluid">
								<div class="pull-right">
									<RaisedButton
										label="Download System Log"
										type="button"
										labelColor="#fff"
										fullWidth={false}
										onClick={this._importSystemLogs}
									/>
								</div>
								<SelectField
									onChange={(event, index, value) => {
										this._getSystemLogs(value);
									}}
									name="selectTemplate"
									value={this.state.older}
									floatingLabelFixed={true}
									hintText="Duration"
									className="selectInput"
									fullWidth={false}
								>
									<MenuItem key={"older_1"} value={1} primaryText={"Last 24 Hours"} />
									<MenuItem key={"older_2"} value={2} primaryText={"Last 2 Days"} />
									<MenuItem key={"older_3"} value={3} primaryText={"Last 3 Days"} />

								</SelectField>
							</div>
						</div>
						<div class="panel panel-default">
							
							<div class="panel-body">
								<Row>
									<Col md={12}>
										{requesting ? <LinearProgress mode="indeterminate" />: <JSONPretty 
											// id="json-pretty"  
											// mainStyle="padding:1em" 
											// valueStyle="font-size:1.1em"  
											theme={JSONPrettyMon}
											style={{fontSize: "1.1em"}} 
											data={logs}
											// space="5"
										>
										</JSONPretty>}
									</Col>
								</Row>
							</div>
						</div>
						
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		system: state.system
	};
};

AdminLogs = withRouter(connect(
	mapStateToProps,
	actions
)(AdminLogs));

export default AdminLogs;


// WEBPACK FOOTER //
// ./src/Components/Pages/Admin/AdminLogs.js